import InterviewQuestions from "../modules/Interviews/InterviewQuestions";
import Dashboard from "../pages/Dashboard";
import Interviews from "../pages/Interviews";
import UserManagement from "../pages/UserManagement";

export const privateRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/interviews",
    element: <Interviews />,
  },
  {
    path: "/interviews/:id",
    element: <InterviewQuestions />,
  },
  {
    path: "/user-management",
    element: <UserManagement />,
  },

];
